<template>
  <div id="funcionarios-toolbar-funcionarios">
    <v-toolbar
      class="mb-2"
      flat>
      <v-toolbar-title
        class="display-1">
        Funcionarios
      </v-toolbar-title>
    </v-toolbar>
  </div>
</template>

<script>
export default {

};
</script>

<style>

</style>
